import { isValidPhoneNumber, MetadataJson, validatePhoneNumberLength } from 'libphonenumber-js/core';
import metadata from 'metadata.custom.json';
import { normalizePhoneFromInput } from 'src/utils/phone';
import { z } from 'zod';

type PhoneValidatorOptionsType = {
  messages?: Partial<{
    required: string;
    min: string;
    max: string;
    invalid: string;
  }>;
};

const phoneValidator =
  ({ messages }: PhoneValidatorOptionsType = {}) =>
  (phone: string, ctx: z.RefinementCtx) => {
    if (!phone) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: messages?.required || 'O celular é obrigatório',
      });
      return;
    }

    const normalizedPhone = normalizePhoneFromInput(phone);
    const isValid = isValidPhoneNumber(normalizedPhone, metadata as MetadataJson);

    if (!isValid) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: messages?.invalid || 'O celular está inválido',
      });
      return;
    }

    const lengthValidation = validatePhoneNumberLength(normalizedPhone, metadata as MetadataJson);

    if (lengthValidation === 'TOO_SHORT') {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: messages?.min || 'O celular está inválido',
      });
      return;
    }

    if (lengthValidation === 'TOO_LONG') {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: messages?.max || 'O celular está inválido',
      });
      return;
    }

    const blackList = ['12345678', '912345678'];

    for (let i = 0; i < 10; i++) {
      blackList.push(`9${i.toString().repeat(8)}`);
      blackList.push(i.toString().repeat(8));
    }

    if (blackList.indexOf(normalizedPhone.slice(5)) > -1) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: messages?.invalid || 'O celular está inválido',
      });
      return;
    }

    return phone;
  };

export default phoneValidator;
